import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Skeleton, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { enqueueSnackbar, useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';
import { regexConstants } from '../../../constants/regEx';
import { getInvoiceApi, updatePartiesApi } from '../apiService';
import { globalGetService, globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
import { formatBytes } from '../../../utils/fileUpload';
import { AttachementsUpload, ButtonLoader, ShowAttachments } from '../../../shared_elements/components';
import { PageLoader, regionalOneInstance } from '../../../shared_elements';
import { setFileUploadDetails } from '../../../shared_elements/actions';
import { getStorage } from '../../../shared_elements/actionCreators';
import { backendDateFormat, fieldDateFormat } from '../../../constants';


const EditInvoiceModal = ({ onToggleModal, getResponseBack,fileUpload }) => {
    const navigate = useNavigate()
    const location = useLocation();
    const dispatch = useDispatch()
    const params = useParams();
    const [invoice, setInvoice] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [attachments, setAttachments] = useState([]);
    const [error, setError] = useState({});
    const [uploadfileList, setUploadfileList] = useState({ mode: '', modal: false, data: null });
    const { storageDetails } = useSelector((state) => state.leases);
    const [isDropDownLoading, setIsDropDownLoading] = useState({ storage: false })
    const textFieldStyle = { '& .MuiInputBase-input': { fontSize: '14px' } };

    useEffect(() => {
        getInvoice();
        trackActivity('Page Viewed', { page_title: 'Edit Invoice' });
    }, []);
  
    const getInvoice = () => {
        setLoading(true);
        setIsDropDownLoading({storage:true});
        globalGetService(getInvoiceApi(params))
            .then(response => {
                if (checkApiStatus(response)) {
                    const data = response.data.data;

                    if (data?.status?.value !== 1) {
                        navigate(`/invoices/view/${data.slug}`, { replace: true });
                        return;
                    }
                dispatch(getStorage({ lease_slug: data?.lease_slug, module_name: "invoices", setIsDropDownLoading }));
                    setInvoice(data);
                }
                setLoading(false);
            });
    };

    const onDeteAttchments = (deltedslug) => {
        setUploadfileList({
            ...uploadfileList, data: {
                ...uploadfileList.data,
                attachments: uploadfileList.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        // setInvoice()
        getInvoice()
    }

    const onFieldChange = (keyParams, value, objectType) => {
        if (objectType) {
            setInvoice({
                ...invoice,
                [objectType]: {
                    ...invoice[objectType],
                    [keyParams]: value
                }
            })
        } else {
            setInvoice({ ...invoice, [keyParams]: value });
        }

    }

    const onEditInvoice = () => {
        let validationInputs = {
            invoice_number: invoice?.invoice_number?.trim()?.length ? '' : 'Please enter Invoice Number',
            date: invoice?.date ? '' : 'Please enter Invoice Date',
            due_date: invoice?.due_date ? '' : 'Please enter Invoice Due Date',
            ...(!(invoice?.parent_slug || [1, 2, 10].includes(invoice?.invoice_type?.value)) && {
                start_date: invoice?.start_date ? '' : 'Please enter Period Start Date',
                end_date: invoice?.end_date ? '' : 'Please enter Period End Date',
            }),
        }

        const invoiceDate = moment(invoice?.date);
        const dueDate = moment(invoice?.due_date);
        const maxAllowedDate = moment(invoice?.lease_end_date).add(3, 'months');
        if (invoice?.date && invoice?.due_date) {
            if (dueDate.isBefore(invoiceDate)) {
                validationInputs.due_date = "Due Date cannot be before Invoice Date";
            }
            if (invoiceDate.isAfter(dueDate)) {
                validationInputs.date = "Invoice Date cannot be after Due Date";
            }
            if (invoiceDate.isBefore(invoice?.lease_start_date)) {
                validationInputs.date = `Invoice Date cannot be before Lease Start Date ${moment(invoice?.lease_start_date).format(fieldDateFormat)}`;
            }
            if (invoiceDate.isAfter(maxAllowedDate)) {
                validationInputs.date = `Invoice Date must be within 3 months after the Lease End Date ${moment(invoice?.lease_end_date).format(fieldDateFormat)}`;
            }
            if (dueDate.isAfter(maxAllowedDate)) {
                validationInputs.due_date = `Due Date must be within 3 months after the Lease End Date ${moment(invoice?.lease_end_date).format(fieldDateFormat)}`;
            }
            if (dueDate.isBefore(invoice?.lease_start_date)) {
                validationInputs.due_date = `Due Date cannot be before Lease Start Date ${moment(invoice?.lease_start_date).format(fieldDateFormat)}`;
            }
            if (!invoice?.lease_slug && invoice?.asset && invoiceDate.isBefore(invoice?.asset?.manufacture_date)) {
                validationInputs.date = `Invoice Date cannot be before Asset Manufacture Date ${moment(invoice?.asset?.manufacture_date).format("DD-MM-YYYY").toUpperCase()}`;
            }
            if (invoiceDate.isBefore(invoice?.parent_invoice_date)) {
                validationInputs.date = `Invoice Date cannot be before Parent Invoice Date (${moment(invoice?.parent_invoice_date).format("DD-MM-YYYY").toUpperCase()})`;
            }
            if (invoice?.due_date && !dueDate.isValid()) {
                validationInputs.due_date = "Please enter valid Due Date";
            }
            if (invoice?.date && !invoiceDate.isValid()) {
                validationInputs.date = "Please enter valid Invoice Date";
            }
        }
        if (!(invoice?.parent_slug || [1, 2, 10].includes(invoice?.invoice_type?.value))) {
            const startDate = moment(invoice?.start_date);
            const endDate = moment(invoice?.end_date);
            if (invoice?.start_date && startDate.isValid() && startDate.isAfter(moment(), 'day')) {
                validationInputs.start_date = "Period Start Date cannot be a future date";
            }
            if (invoice?.start_date && invoice?.end_date) {
                if (endDate.isBefore(startDate)) {
                    validationInputs.end_date = "Period End Date cannot be before Period Start Date";
                }
                if (startDate.isAfter(endDate)) {
                    validationInputs.start_date = "Period Start Date cannot be after Period End Date";
                }
                if (invoice?.end_date && !endDate.isValid()) {
                    validationInputs.end_date = "Please enter valid Period End Date";
                }
                if (invoice?.start_date && !startDate.isValid()) {
                    validationInputs.start_date = "Please enter valid Period Start Date";
                }
                if (invoice?.lease_slug) {
                    if (startDate.isBefore(invoice?.lease_start_date)) {
                        validationInputs.start_date = `Period Start Date cannot be before Lease Start Date ${moment(invoice?.lease_start_date).format(fieldDateFormat)}`;
                    }
                    if (startDate.isAfter(invoice?.lease_end_date)) {
                        validationInputs.start_date = `Period Start Date cannot be after Lease End Date ${moment(invoice?.lease_end_date).format(fieldDateFormat)}`;
                    }
                    if (endDate.isAfter(invoice?.lease_end_date)) {
                        validationInputs.end_date = `Period End Date cannot be after Lease End Date ${moment(invoice?.lease_end_date).format(fieldDateFormat)}`;
                    }
                    if (endDate.isBefore(invoice?.lease_start_date)) {
                        validationInputs.end_date = `Period End Date cannot be before Lease Start Date ${moment(invoice?.lease_start_date).format(fieldDateFormat)}`;
                    }
                }
            }
        }

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            const { hub_account, vat_number, customer_reference_number, ...invoiceWithoutRegionalFields } = invoice;
            const payload = regionalOneInstance ? { ...invoice, currency: invoice?.currency?.code } : { ...invoiceWithoutRegionalFields, currency: invoice?.currency?.code };
            globalPutService(updatePartiesApi(), payload)
                .then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'updated')
                        }
                        getResponseBack()
                        onToggleModal()
                        trackActivity('Item Edited', { page_title: `Edit Invoice`, success_msg: response?.data?.message, item_id: invoice?.id, payload: invoice, response: response?.data })
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        setLoading(false);
                    } else {
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Invoice`, error_msg: response?.data?.message, item_id: invoice?.id, payload: invoice, response: response?.data })
                    }
                })
        } else {
            setError(validationInputs)
            trackActivity(`Item Edited`, { page_title: `Edit Invoice`, error_msg: validationInputs })
        }
    }

    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Edit Invoice`, page_type: page_type, })
    }
   
    return (
        <>
            <Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' maxWidth='md' fullWidth open={true} scroll='paper'>
                <DialogTitle sx={{ m: 0, p: 2, pl: 3 }} className='dialog-header' id="customized-dialog-title">
                    {invoice?.invoice_type?.label ? <>
                        {invoice?.parent_slug ? <Typography className="delivery-header btn-primary" color="primary">
                            Edit {invoice?.invoice_type?.label} {invoice?.invoice_type?.value === 3 ? `Invoice` : `Note`}
                        </Typography> :
                            <Typography className="delivery-header btn-primary" color="primary">
                                Edit {invoice?.invoice_type?.label} Invoice
                            </Typography>}
                    </> : <Skeleton variant="text" width={150} height={40} />}
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                required
                                id="invoice_number"
                                value={invoice?.invoice_number || ''}
                                label="Invoice Number"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                onFocus={() => onRestErrorKey("invoice_number")}
                                slotProps={{ inputLabel: { shrink: true } }}
                                onChange={(e) => { regexConstants.noStartingSpace.test(e.target.value) ? onFieldChange('invoice_number', e.target.value) : e.preventDefault() }}
                                fullWidth
                                error={error?.invoice_number}
                                helperText={error?.invoice_number}
                            // sx={{ ...textFieldStyls }}
                            />
                        </Grid>
                        {!(invoice?.parent_slug || [1, 2, 10].includes(invoice?.invoice_type?.value)) && <>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Period Start Date"
                                    value={invoice?.start_date ? moment(invoice?.start_date) : null}
                                    maxDate={moment()}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("start_date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("start_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error?.start_date || false,
                                            helperText: error?.start_date || '',
                                            onFocus: () => {
                                                if (error?.start_date) {
                                                    onRestErrorKey("start_date");
                                                }
                                            }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("start_date", null);
                                                onRestErrorKey("start_date");
                                            }
                                        }
                                    }}
                                    sx={{ width: "100%", ...textFieldStyle }}
                                    format={fieldDateFormat}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Period End Date"
                                    value={invoice?.end_date ? moment(invoice?.end_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("end_date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("end_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error?.end_date || false,
                                            helperText: error?.end_date || '',
                                            onFocus: () => {
                                                if (error?.end_date) {
                                                    onRestErrorKey("end_date");
                                                }
                                            }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("end_date", null);
                                                onRestErrorKey("end_date");
                                            }
                                        }
                                    }}
                                    sx={{ width: "100%", ...textFieldStyle }}
                                    format={fieldDateFormat}
                                />
                            </LocalizationProvider>
                        </Grid>
                        </>}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Invoice Date"
                                    value={invoice?.date ? moment(invoice?.date) : null}
                                    maxDate={ (invoice?.lease_end_date) ? moment(invoice?.lease_end_date).add(3, 'months') : null }
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error?.date || false,
                                            helperText: error?.date || '',
                                            onFocus: () => {
                                                if (error?.date) {
                                                    onRestErrorKey("date");
                                                }
                                            }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("date", null);
                                                onRestErrorKey("date");
                                            }
                                        }
                                    }}
                                    sx={{ width: "100%", ...textFieldStyle }}
                                    format={fieldDateFormat}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Due Date"
                                    value={invoice?.due_date ? moment(invoice?.due_date) : null}
                                    minDate={moment(invoice?.date)}
                                    maxDate={ (invoice?.lease_end_date) ? moment(invoice?.lease_end_date).add(3, 'months') : null }
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("due_date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("due_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error?.due_date || false,
                                            helperText: error?.due_date || '',
                                            onFocus: () => {
                                                if (error?.due_date) {
                                                    onRestErrorKey("due_date");
                                                }
                                            }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("due_date", null);
                                                onRestErrorKey("due_date");
                                            }
                                        }
                                    }}
                                    sx={{ width: "100%", ...textFieldStyle }}
                                    format={fieldDateFormat}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="custom_export_title"
                                value={invoice?.custom_export_title || ''}
                                label="Custom Invoice Title"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                onFocus={() => onRestErrorKey("custom_export_title")}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                                onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("custom_export_title", e.target.value.trimStart()) : e.preventDefault() }}
                                fullWidth
                            />
                        </Grid>
                        {regionalOneInstance && [
                            { key: "hub_account", label: "Hub Account" },
                            { key: "vat_number", label: "VAT Number" },
                            { key: "customer_reference_number", label: "Customer Reference Number" },
                        ].map((field) => (
                            <Grid key={field.key} size={{ md: 4, xs: 12 }}>
                                <TextField
                                    id={field.key}
                                    value={invoice?.[field.key] || ''}
                                    label={field.label}
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 50 } }}
                                    onChange={(e) => { regexConstants.alphanumericWithSpace.test(e.target.value) || e.target.value === "" ? onFieldChange(field.key, e.target.value.trimStart()) : e.preventDefault() }}
                                    fullWidth
                                />
                            </Grid>
                        ))}
                        {invoice?.invoice_type?.label === 'Rental' ? <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                id="description"
                                label="Description"
                                variant="outlined"
                                size='small'
                                margin='normal'
                                value={invoice?.description || ''}
                                onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("description", e.target.value.trimStart()) : e.preventDefault() }}
                                slotProps={{ inputLabel: { shrink: true } }}
                                fullWidth
                                multiline
                                rows={3}
                                sx={{ ...textFieldStyle, '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' }  }}
                            />
                        </Grid> : null}
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                id="remarks"
                                label="Remarks"
                                variant="outlined"
                                size='small'
                                margin='normal'
                                value={invoice?.remarks || ''}
                                onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault() }}
                                slotProps={{ inputLabel: { shrink: true } }}
                                fullWidth
                                multiline
                                rows={3}
                                sx={{ ...textFieldStyle, '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' }  }}
                            />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                id="footer_note"
                                label="Footer Note"
                                variant="outlined"
                                size='small'
                                margin='normal'
                                value={invoice?.footer_note || ''}
                                onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("footer_note", e.target.value.trimStart()) : e.preventDefault() }}
                                slotProps={{ inputLabel: { shrink: true } }}
                                fullWidth
                                multiline
                                rows={3}
                                sx={{ ...textFieldStyle, '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' }  }}
                            />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 1 }}>
                            <Box className="responsive-buttons">
                                {invoice?.id && invoice?.attachments?.length ?
                                    <Button onClick={() => { setUploadfileList({ modal: true, data: invoice, mode: 'view' }); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({invoice?.attachments?.length})Attachment(s)</Button> : <Button disableRipple color='primary' variant='outlined' size='small' sx={{ marginBottom: '10px' }}>Attachments</Button>
                                }
                                <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary' endIcon={isDropDownLoading?.storage ? <ButtonLoader size={15} /> : null}>{`Available Space : ${isDropDownLoading?.storage ? "" : formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            <AttachementsUpload onFileChange={handleFileChange} attachments={invoice?.attachments} remainingStorage={storageDetails?.remaining_storage} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ marginRight: "15px" }}>
                    <Button className='cancel-btn' variant='outlined' size='small' disabled={isLoading} onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }} > Cancel </Button>
                    <Button variant='contained' className='btn-primary' size='small' onClick={() => { handleItemClicked('Save Button'); onEditInvoice(); }}>
                        {isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"}
                    </Button>
                </DialogActions>
            </Dialog>
            {
                uploadfileList.modal ? <ShowAttachments
                    moduleName="Invoice"
                    url='delete-attachment'
                    attachmentsData={uploadfileList}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setUploadfileList({ modal: false, data: null, mode: '' })}
                    onViewDisabled={uploadfileList?.mode === 'view'}
                    permissionKey='invoices'
                /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </>
    )
}

export default EditInvoiceModal